<template>
    <!-- Główny kontener widoku HomeView -->
    <div class="users content-container flex-column">
      <div class="content-wrap">
        <!-- Pasek menu u góry (bez zawartości sekcji użytkowników) -->
        <div class="d-flex users-section-container no-content">
          <div class="users-section"></div>
          <div class="content-wrap">
            <!-- Komponent górnego menu -->
            <TopMenu />
          </div>
        </div>
  
        <!-- Sekcja z tytułem "Dewiacja kalibracji" i komponentem kalibracji -->
        <div class="d-flex users-section-container">
        <div class="users-section">
          <!-- Nagłówek sekcji: wyświetla przetłumaczony tekst kalibracji -->
          <!-- <span>{{ t('calibration-deviation') }}</span> -->
          <span>Dewiacja kalibracji</span>
          <FilterCalibrationData />
        </div>
          <div class="content-wrap">
            <div class="header d-flex justify-content-between align-items-center"> 
             <!-- Tytuł strony wyświetlany dużymi literami -->
                <!-- <h3>{{ t('calibration').toUpperCase() }}</h3> -->
                <!-- <h3>DEWIACJA KALIBRACJI</h3> -->
            </div>

          <!-- widok listy kalibracji -->
            <div class="collapse show" id="userHistory" v-if="!isAdding">
                <CalibrationDeviation />
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import TopMenu from "../components/TopMenu.vue"; // import komponentu górnego menu
import CalibrationDeviation from "@/components/CalibrationDeviation"; // import komponentu kalibracji
import FilterCalibrationData from "@/components/FilterCalibrationData";
// import moment from "moment"; // biblioteka do pracy z datami

export default {
  name: "CalibrationDeviationView",
  components: {
    TopMenu,
    CalibrationDeviation,
    FilterCalibrationData,
  },
  data() {
  },
  methods: {
    // addLastCalibrationTime() {
    //   this.isAdding = !this.isAdding; // przełączamy stan dodawania ostatniej daty kalibracji
    //   if (this.isAdding) {
    //     this.selectedDateTime = null; // wyczyść przy otwarciu
    //   }
    // },
    /**
     * Funkcja pobierająca archiwum logów użytkowników
     * z zakresu ostatnich 7 dni i inicjująca pobranie pliku
     */
    // retrieveZip() {
    //   this.isDownloading = true; // ustawiamy stan ładowania
    //   // wyznaczamy datę początkową (7 dni wstecz)
    //   const dateFrom = moment().subtract(7, "days").toISOString(false);
    //   // wyznaczamy datę końcową (aktualny czas)
    //   const dateTo = moment().toISOString(false);

    //   // wywołujemy serwis, który zwraca link do ZIP-a
    //   Users.getZip(dateFrom, dateTo)
    //     .then((data) => {
    //       // następnie pobieramy sam plik pod wskazanym linkiem
    //       Users.fetch(data.link)
    //         .then((response) => {
    //           // tworzymy ukryty element <a> do pobrania pliku
    //           const link = document.createElement("a");
    //           link.href = URL.createObjectURL(response);
    //           link.download = "user_logs"; // proponowana nazwa pliku
    //           link.click(); // inicjujemy pobranie
    //           this.isDownloading = false; // kończymy stan ładowania
    //           URL.revokeObjectURL(link.href); // usuwamy obiekt URL po pobraniu
    //         })
    //         .catch(console.error); // obsługa błędu przy pobieraniu pliku
    //     })
    //     .catch((error) => {
    //       this.isDownloading = false; // reset stanu ładowania w razie błędu
    //       console.error(error); // wyświetlamy błąd w konsoli
    //     });
    // },
  },
};
</script>

<style scoped>
/* Kontener sekcji użytkowników i zawartości */
.users-section-container {
  width: 100%;
}

/* Pasek filtrów po lewej stronie (tło z obrazkiem) */
.users-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

/* Stylowanie nagłówka sekcji (span wewnątrz .users-section) */
.users-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

/* Stylowanie tytułu <h3> w .content-wrap */
.content-wrap h3 {
  background-color: white;
  padding: 10px 20px;
  margin-bottom: 0;
  position: relative;
}

/* Styl przycisku wewnątrz <h3> (jeśli będzie użyty) */
h3 button {
  position: absolute;
  right: 20px;
  top: 17%;
  background-color: #e0e0e0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  min-height: 28px;
  font-size: 12px;
  padding: 0;
  border: 0;
}

/* Pozostałe ikony i stany collapse */
.no-content {
  min-height: auto;
}
.icon {
  margin: 5px;
  height: 15px;
  width: 35px;
}
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}
.header {
  background-color: #fff;
}
.add {
  margin-right: 1rem; 
  font-weight: bold; 
  font-size: large; 
  background-color: #fff;
}
</style>
